"use strict";
import { Grid } from "@alifd/next";
import React from "react";
const { Col, Row } = Grid;
export const Title = (props) => {
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { span: 12 }, /* @__PURE__ */ React.createElement("h3", null, props.title)), /* @__PURE__ */ React.createElement(Col, { span: 12, className: "flexright" }, /* @__PURE__ */ React.createElement("div", { style: { padding: "12px 8px 0 0" } }, props.actions.map((item) => {
    return item;
  }))));
};
